import { Close, ErrorOutlined } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, Divider, IconButton, Stack, Typography } from '@mui/material';
import { EmptyStateAvatar } from 'components/ui/empty-state-avatar';
import { FileInstanceInformation } from 'middleware-types';
import { useDeleteFileInstance } from '../hooks/files/use-delete-file-instance';

interface DeleteFileInstanceModalProps {
	file: FileInstanceInformation;
	onClose: () => void;
}

export const DeleteFileInstanceModal = ({ file, onClose }: DeleteFileInstanceModalProps) => {
	const { deleteFileInstance, loading } = useDeleteFileInstance();
	const onSubmit = () => {
		deleteFileInstance(file.id, file.fileId, file.folder?.id).then((success) => {
			if (!success) return;
			onClose();
		});
	};

	return (
		<Stack>
			<Stack
				px={2}
				py={1}
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				spacing={1}>
				<Typography variant="h3">Are you sure?</Typography>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Stack>
			<Divider />
			<Stack alignItems="center" textAlign="center" px={10} py={3}>
				<EmptyStateAvatar
					avatarProps={{ bgcolor: 'error.50' }}
					iconProps={{ color: 'error.500' }}
					icon={<ErrorOutlined />}
				/>
				<Typography variant="h1" marginTop={2} sx={{ wordBreak: 'break-word' }}>
					Delete {file.fileName} (v{file.versionNumber})?
				</Typography>
				<Typography variant="body1" sx={{ marginTop: '4px' }}>
					This file version will be deleted. This action cannot be undone.
				</Typography>
			</Stack>
			<Divider />
			<Stack direction="row" justifyContent="flex-end" px={2} py={1.5} spacing={1.5}>
				<Button size="large" variant="outlined" onClick={onClose}>
					Cancel
				</Button>
				<LoadingButton
					size="large"
					variant="contained"
					color="error"
					loading={loading}
					onClick={onSubmit}>
					Delete
				</LoadingButton>
			</Stack>
		</Stack>
	);
};
